export const otpCode = {
  incorrect: "Incorrect code. Please try again.",
  expired: "Code expired. Please try again.",
  resendError:
    "Sorry, there was a problem resending your code. Please retry or contact your IT support staff if the issue persists."
};
